import { APIResult } from 'src/modules/models/api-result';

export class InvoiceSearchResult extends APIResult {
    data: any = []
    total: number = 0;
}

export class InvoicePreviewResult extends APIResult {
    data: string;
}